import { all } from "redux-saga/effects";
import { watchFetchUsers } from "./userSaga";
import { watchQuestionActions } from "./questionSaga";
import {watchExamSaga} from "./examSaga";

export default function* rootSaga() {
  yield all([
    watchFetchUsers(),
    watchQuestionActions(),
    watchExamSaga(),
  ]);
}
